<template lang="pug">
Page
  template(slot="header-breadcrumb-left")
    .Breadcrumb.m-top-5
      router-link.c-light(
        id="approved-order-breadcrumb"
        :to="{ name: 'Orders' }"
      ) {{ $t('Orders.breadcrumb_ApprovedOrders') }}
      span {{ ">" }}
      .relative-pairs-tooltip
        a(href="" id="approved-order-detail-breadcrumb-active-spot-list").isSelected {{ headerInfo?.orderNumber }}
        PairsTooltip(
          :list="breadCrumbHoverInfo"
          itemKey="key"
          itemValue="value"
        )
  
  template(slot="header-left-dropdown")
    PageTabButtons.m-left-10(
      :selectedList="requestHeaderLinks"
      translationGroup="Request"
      matchedRoute="Orders"
    )

  template(slot="header-right-content")
    Button(
      id="btn-approved-order-detail-new"
      type="button",
      primary
      size="medium"
      iconName="icon-global-add"
      iconClass="icon-global-add"
      v-if="approveOrdersDetail.length"
      @click="addNewDetail")
        span {{ $t('Global.addNewStock') }}
  

  template(slot="toolbar-left")

  template(slot="toolbar-right")

  template(slot="content-center")
    NoPermission(v-if="!hasTabPermission")
      // TOOLBAR

    TableLoading.sticky(v-if="isFetchingPageData || isFetchingOrderList")
    EmptyState(
    v-if="!approveOrdersDetail.length && !isFetchingPageData && !isFetchingOrderList"
    :title="$t('Orders.orders_emptyState_NotFound_Title')"
    :description="$t('Orders.orders_emptyState_NotFound_Description')")

    TableView(
      v-if="approveOrdersDetail.length",
      :fields="ordersDetailFields",
      :actions="hasOrderEdit ? ['edit'] : ['']"
      :readOnly="!hasOrderEdit"
      :data="approveOrdersDetail"
      :usePortalAction="true"
      @delegateOnItemEdit="editDetailAction"
    )

    portal(to="detailDescription")
      div(slot-scope="row")
        Button.show-MiniPopup.relative.width-max-content(
          iconName="icon-global-info",
          :justIcon="true",
          :id="`orders-detail-info-button-${row.rowIndex}`"
          v-if="row.description",
          class="btn-info"
        )
          .MiniPopup-leftCenter-primary.m-top-15.c-dark
            span {{ row.description }}
        span(v-else) -

    router-view(@getList="getList")

</template>

<script>
// mixin
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { getOrdersDetailFields } from './fields/approvedOrders'
import NoPermission from '@/view/global/has-not-permission'
import hasTabPermission from '@/mixins/hasTabPermission'
import PairsTooltip from '@/view/global/pairs-tooltip'

export default {
  name: 'OrdersDetail',
  mixins: [
    hasTabPermission
  ],
  data () {
    return {
      ordersDetailFields: getOrdersDetailFields(this.$t),
      headerInfo: null
    }
  },
  components: {
    NoPermission,
    PairsTooltip
  },
  computed: {
    ...mapGetters('Request', ['requestHeaderLinks']),

    ...mapGetters('Orders', [
      'approveOrdersDetail',
    ]),

    ...mapGetters('Settings', [
      'checkPermission'
    ]),

    breadCrumbHoverInfo () {
      return [
        {
          key: this.$t('Global.toolbar_Supplier_Label'),
          value: this.headerInfo.supplierName
        },
        {
          key: this.$t('Global.toolbar_Store_Label'),
          value: this.headerInfo.storeName
        },
        {
          key: this.$t('Orders.order_header_totalAmount'),
          value: this.headerInfo.netTotalAmount
        },
        {
          key: this.$t('Orders.order_header_taxAmount'),
          value: this.headerInfo.taxTotalAmount
        }
      ]
    },

    hasOrderEdit () {
      return this.checkPermission('OrderEdit')
    },

    isFetchingPageData () {
      return this.$wait.is(['pageLoading'])
    },
    isFetchingOrderList () {
      return this.$wait.is('fetchingOrderList')
    }
  },
  methods: {
    ...mapActions('Orders', [
        'getOrdersHeader',
        'getApprovedOrderDetail',
        'fetchApprovedOrderHeader'
      ]),

    ...mapActions('Notify', ['notifyShow']),

    getList () {
      this.getApprovedOrderDetail({ orderHeaderId: this.$route.params.orderHeaderId })
    },

    async getHeaderData () {
      this.fetchApprovedOrderHeader(this.$route.params.orderHeaderId).then(res => {
        if (res) this.headerInfo = res.data.orderHeader
      })
    },

    addNewDetail (order) {
      this.$router.push({
        name: 'orderAddStock',
        params: {
          id: order.id
        }
      })
    },
    editDetailAction (item) {
      this.$router.push({
        name: 'OrderDetailEdit',
        params: {
          id: item.headerId,
          detailId: item.id
        }
      })
    }
  },

  beforeMount () {
    if (!this.hasTabPermission) return
    this.getHeaderData()
  },

  async created () {
    await this.getList()
  }
}
</script>

<style lang="scss" scoped>

@import "~@/stylesheet/config/mixin";

.MiniPopup {
  right: calc(26px);
  width: max-content;
}


.PageHeader {
  padding: 0;
  .right {
    align-self: center;
    display: flex;
    .form-item-select {
      min-width: 200px;
      flex-shrink: 0;
    }
  }
}
.pageLoading {
  top: inherit;
}

.btn-info {
  .icon {
    width: 24px;
    height: 24px;
  }
}

:deep() .status-title{
  width: 500px;
}

.sticky {
  z-index: $z-index-md;
  position: sticky !important;
  left: 50%;
  top: 50%;
}

:deep() .action-box {
  width: 180px !important;
}

:deep() .resendButton {
  right: 37px !important;
  position: relative;
}

  :deep(.datepicker-ui .txt) {
    padding: unset !important;
  }
  :deep(.form-item-select .icon-down-arrow) {
    right: 6px !important;
  }
  .Breadcrumb {
    display: flex;
    font-size: $font-size-small;

    span {
      margin-left: 10px;
      margin-right: 10px;
    }

    .isSelected {
      color: $color-primary;
      font-weight: $font-weight-bold;
      pointer-events: none;
    }
  }
</style>